/* tslint:disable */
/* eslint-disable */
export enum OtherFinanceCommitmentType {
  HomeLoan = 'HomeLoan',
  CarLoan = 'CarLoan',
  PersonalLoan = 'PersonalLoan'
}
